import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const ErrorModal = ({ isOpen, toggle, error, status }) => {
  // Determine error icon and styling based on status code
  const getErrorIcon = () => {
    if (status === 402) {
      // Payment required
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z' fill='#FFA500' fillOpacity='0.15' />
          <path d='M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z' fill='#FFA500' />
          <path d='M12 9V12' stroke='#FFF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          <path d='M12 15H12.0083' stroke='#FFF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      );
    }

    // Default error icon (red)
    return (
      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z' fill='#FF3B30' fillOpacity='0.15' />
        <path d='M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z' fill='#FF3B30' />
        <path d='M12 9V12' stroke='#FFE2E0' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M12 15H12.0083' stroke='#FFE2E0' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      </svg>
    );
  };

  const getErrorTitle = () => {
    if (status === 402) return 'Payment Required';
    if (status === 400) return 'Invalid Request';
    if (status === 403) return 'Access Denied';
    if (status === 404) return 'Not Found';
    if (status === 500) return 'Server Error';
    return 'Error';
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className='main-modal modal-dialog-centered new-user-modal error-modal'
      backdrop="static"
    >
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody>
        <div className='content-area'>
          <div className='delete-modal' style={{ paddingTop: '10px' }}>
            <h4 style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <i className='icon' style={{ display: 'flex', alignItems: 'center' }}>
                {getErrorIcon()}
              </i>
              <span>{getErrorTitle()}</span>
            </h4>
            <p style={{ marginBottom: '20px', lineHeight: '1.6', color: '#555', paddingLeft: '36px', paddingRight: '10px' }}>
              {error || 'An error occurred. Please try again.'}
            </p>
            <div className='form-area'>
              <div className='btns-box text-right'>
                <button className='btn-style-new' onClick={toggle}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ErrorModal;
